import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href=''
      className='link footer__link'
    >
      Created By Imer Lopez
    </a>
  </footer>
)

export default Footer
